import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';
import * as Constants from 'src/constants';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-10-24'
        tag='Etsy'
        title='Etsy Seller Protection: What It Is and How It Works'
      >
        <p>
          Etsy is a marketplace that has been around since 2005 and continues to grow in popularity. With over 7 million
          active sellers on the platform, Etsy provides buyers with unique products they can't find anywhere else.
          However, with such an expansive community comes potential risks for both buyers and sellers alike.
        </p>
        <p>
          For example, some scams may occur where one party never receives their product or gets a counterfeit version
          instead of what was ordered. Fortunately, Etsy is not alone in having scenarios like this. All marketplaces
          have certain protections in place to protect their buyers and sellers from disputes and ineligible claims.
        </p>
        <p>
          The Etsy Purchase Protection program is a policy put in place to protect both buyers and sellers. This type of
          protection comes into play when disputes arise, which often happens on marketplaces like Etsy. When it comes
          to resolving these disputes, this guide will walk you through how Etsy seller protection works, how you can be
          eligible for the protection, and things to consider to avoid cases being opened against you in your Etsy shop.
        </p>

        <h3>What is Etsy's Seller Protection</h3>
        <p>
          Etsy protects both its buyers and sellers in the event of a disagreement. Etsy built Etsy's Purchase
          Protection Program for their buyers and sellers to ensure that both parties are protected and have a positive
          shopping experience on the platform.
        </p>
        <p>
          The policy applies to cases where an item does not arrive and disputes in listing accuracy. Etsy offers
          protection assistance to eligible sellers with disputes mentioned above. Etsy may cover customer refunds for
          orders up to $250, as long as the seller is eligible for seller protection and complies with Etsy's policies.
        </p>
        <h4>Non-Delivery</h4>
        <p>
          Etsy Purchase Protection protects sellers in cases opened against them where an item is shipped but did not
          arrive at its intended destination. Etsy will cover up to $250 of buyer's refund for sellers who meet the
          eligibility criteria.
        </p>
        <h4>Not-As-Described</h4>
        <p>
          Etsy Purchase Protection protects sellers for orders that buyers disputed as “not-as-described” but match the
          listing description and photos exactly. However, if the buyer's claim is valid, Etsy will not cover the
          buyer's refund from orders different from the listing description.
        </p>
        <h4>Damaged Items</h4>
        <p>
          The Etsy Purchase Protection Program does not apply in the case of damaged items. However, Etsy may cover the
          seller's first damaged item starting August 01, 2022, and once for each calendar year (January - December).
          Thereafter, sellers are accountable for resolving opened cases of reported damaged items.
        </p>

        <h3>How to Qualify for Seller Protection</h3>
        <p>
          Etsy seller protection is a way for sellers to have peace of mind that their interests are protected. To
          ensure you are protected from any disputes, you must comply with Etsy's Seller Protection Policy and remain in
          good standing with Etsy.
        </p>
        <p>To stay in good standing, you must:</p>
        <ul>
          <li>Sell qualifying items</li>
          <li>Ship your buyer's order(s) on time</li>
          <li>Respond to messages promptly</li>
        </ul>
        <p>
          To guarantee that you will be covered under Etsy's Purchase Protection Program, you have to make sure to
          comply with the following:
        </p>
        <ul>
          <li>
            Use a valid tracking number. You may buy shipping labels directly on Etsy, or if you prefer to ship them on
            your own, make sure to provide Etsy with a valid tracking number that shows the delivery address and
            shipment progress. The address must be the same on the Etsy receipt.
          </li>
          <li>
            Use Etsy's Checkout Payment. You will only be eligible for Etsy Seller Protection when you accept payments
            through Etsy Payments. For PayPal transactions, customers will be directed to handle cases through PayPal.
          </li>
          <li>
            Ship orders to the address on the Etsy Receipt. You must ship the orders to the buyer's address on the Etsy
            receipt. Otherwise, if the buyer requested an alternate shipping address through Messages, you may choose to
            cancel and refund and ask the buyer to repurchase with the corrected shipping address.
          </li>
          <li>
            Package your items securely. To prevent things from being damaged while in transit, it's vital to package
            your items as securely as possible. For delicate ones, ensure enough fillers and cushions for extra
            protection, or add shipping insurance.
          </li>
          <li>
            Ship orders on time. You must include processing times on your listing to set your customers' delivery
            expectations. Your listing must also have an Estimated Delivery Date (EDD), which provides transit times and
            zip code (if applicable). Any information agreements made in Etsy Message to change the shipping date will
            not qualify.
          </li>
          <li>
            Fill out Shop Policies. You must fill out all essential policies of your shop, from returns, exchanges, or
            custom orders. Your shop policies must align with Etsy's policies and local laws.
          </li>
          <li>
            Maintain Good standing. Keeping your shop in good standing makes you qualify for seller protection. Being in
            good standing also means you're complying with Etsy's policies.
          </li>
        </ul>
        <p>
          Etsy's seller protection covers up to $250. Sellers are responsible for refunding costs for orders over the
          $250 threshold, including shipping & taxes, or damages incurred in transit following the first case covered by
          Etsy.
        </p>
        <p>
          If the seller has obtained third-party insurance, carrier, or payment processor coverage, Etsy may ask to
          submit a claim to their primary coverage first. Etsy may process a refund only when other coverages do not
          apply.
        </p>

        <h3>All About Etsy's Case System</h3>
        <p>
          Etsy's case system is built to help sellers and buyers have a fair chance of participating in the marketplace
          without fear of being scammed. It is a platform where both parties can work together to resolve their problems
          concerning their orders.
        </p>
        <p>
          If you and the customer cannot resolve the matters on your own, the buyer can open a case after 48 hours of
          messaging you, and an Etsy specialist will step in and mediate the issue. The Etsy agent will oversee the
          matter and determine if the order and your shop qualify for Seller protection.
        </p>
        <p>
          Etsy specialists may request more information to resolve the case. All information will be in the case log and
          must be submitted to the Etsy specialist within the given time frame to avoid penalizing your account. After
          Etsy has gathered all the necessary information and has reviewed the dispute, they will either provide you
          with specific directions on how to resolve the dispute or may issue a refund for the order if you qualify for
          seller protection.
        </p>
        <p>
          The Seller Protection Policy doesn't guarantee you a resolution in your favor. If your buyers' claim is valid,
          you are financially responsible for refunding them. Sellers who don't comply with Etsy's policies are subject
          to review, which can result in the suspension of the account and/or termination.
        </p>

        <h3>Eligible Cases</h3>
        <p>
          Not all buyers can open a case against the seller. For a claim to be opened on Etsy, the order must meet the
          following criteria:
        </p>
        <ol>
          <li>
            The order must be made within the eligible time frame to open a case. It must be based on an order's
            estimated delivery date (if applicable) or processing time based on the “ship by” date.
          </li>
          <li>
            The buyer must first report the concern to the seller by selecting <strong>Help with Order</strong> within
            the Purchases and Reviews section. The seller will be notified of the help request and given 48 hours to
            resolve the matter.
          </li>
          <li>
            If the buyer and the seller cannot resolve the order issue, the buyer can open a case against the seller.
            The buyer can only open a case for the following issues:
            <ul>
              <li>Item never arrived.</li>
              <li>Item arrives but does not match the listing description and photo.</li>
              <li>The item arrived damaged.</li>
            </ul>
          </li>
        </ol>

        <h3>What Happens if Sellers Don't Comply with Etsy's Policies</h3>
        <p>
          Cases opened against you can be prevented by complying with Etsy's policies for good customer service, timely
          shipping, and accurate listings and photos. As an Etsy seller, you are expected to provide memorable customer
          service experiences resulting in positive feedback, word-of-mouth promotion, and increased traffic of repeat
          purchases.
        </p>
        <p>
          Sellers who fail to follow Etsy's policies are subject to review, which can result in their accounts being
          penalized, such as account privileges suspensions and/or termination.
        </p>
        <p>
          In the event that you oppose the outcome of a case opened against you, especially for closed cases of “Item
          different than described” or “Item arrived damaged,” you may contact Etsy, and they'll take a second look.
          Etsy's case resolution aligns with Etsy's policies and Etsy's Purchase Protection Program.
        </p>

        <h3>How to Avoid Disputes</h3>
        <p>
          When a customer opens a case against a seller, the seller has an opportunity to resolve it or defend
          themselves before they are penalized. Sellers can avoid disputes in the first place by following Etsy's
          policies and maintaining good standing.
        </p>
        <p>Here are some ways to prepare your Etsy shop to avoid disputes:</p>
        <ul>
          <li>Ensure to comply with Etsy's Seller Protection Policy to protect you if disputes arise.</li>
          <li>
            Fill out your shop policies. You must include guidelines for returns, refunds, and damaged items. It helps
            set your buyer's expectations and may protect you from buyer order issues. Make sure your shop policies are
            in line with Etsy's policies.
          </li>
          <li>
            Responding to your buyers' messages. Immediate response to order issues can help prevent disputes from
            arising. If the buyer sends a help request, ensure to resolve it within 48 hours, or they can open a case if
            they're not satisfied with the resolution.
          </li>
          <li>
            Ship your orders on time. Include processing times in your listings, and add an estimated delivery date (if
            applicable) so your buyers know when to expect the shipments.
          </li>
          <li>Make sure to list and ship items exactly how you describe them on your Etsy listings.</li>
          <li>Package fragile items with extra protection to prevent damage during transit.</li>
        </ul>
        <p>
          In the event that a buyer opens a case against you, Etsy's policies take precedence over your shop's policies.
        </p>

        <h3>How to Resolve a Case</h3>
        <p>
          The case will automatically close once the issue has been addressed or when a buyer is satisfied with the case
          resolution. Cases are closed automatically on the following events:
        </p>
        <ul>
          <li>After you issue the buyer a full refund through Etsy Payments</li>
          <li>
            For non-delivery cases, no valid tracking information is provided, or the order's tracking information shows
            that the parcel was not delivered to the address on the Etsy receipt.
          </li>
          <li>The buyer is satisfied with the case resolutions and closes the case.</li>
        </ul>
        <p>
          Etsy may contact you to request more information on any open case to help resolve the matter. When Etsy
          reaches out to you, you must respond within the given time frame. If you have to issue buyers a full refund
          and they paid using a PayPal account and not through Etsy Payments, you need to provide Etsy with proof of a
          PayPal refund before the case can be closed.
        </p>
        <p>
          To ensure that you are covered under Seller Protection and will win on the cases opened against you, make sure
          to consider the following:
        </p>
        <h4>Non-delivery case</h4>
        <ul>
          <li>Provide a valid tracking number with proof of shipment</li>
          <li>Make sure to ship only to the address on the Etsy receipt</li>
          <li>Ship orders within the processing time or “ship by” date</li>
        </ul>
        <h4>Item not-as-described case</h4>
        <ul>
          <li>Take photos using natural light to display its precise colors</li>
          <li>Ensure your item matches what is described on your Etsy listing and photos</li>
          <li>Disclose any flaws and defects of your items on your pictures and description</li>
        </ul>
        <p>
          The Etsy Purchase Protection program for sellers is not an insurance policy, warranty, or guarantee that you
          will be protected in each order issue. Etsy has the right to decide whether they will grant you protection
          under the Etsy Purchase Protection program or not. In addition, Etsy reserves the right to resolve the case on
          behalf of sellers if necessary, which can include issuing a refund and recouping funds from your Payment
          account.
        </p>

        <h3>Handle Disputes and Cases like a Pro</h3>
        <p>
          Dealing with disputes and cases opened against you can be an overwhelming and time-consuming task. You have to
          communicate with your customers professionally and find a better resolution that would benefit you and the
          customer.
        </p>
        <p>
          However, some things are beyond our control. Know that you are not alone; even an experienced seller has to
          handle disputes, order issues, and other things simultaneously. In unforeseen situations like this, having an
          automated service you can rely upon always comes in handy.
        </p>
        <p>
          Automation services like OneShop act as your virtual assistant and marketing expert. It helps you monitor your
          shop's performance, do automated listing tasks, and many other features to save you time and make your online
          selling business much more manageable.
        </p>
        <p>
          One great feature of OneShop that many resellers benefit from is its cross-listing function that allows you to
          seamlessly cross-list into multiple marketplaces integrated with our platform in just a few clicks. It lets
          you reach out to more potential customers and, ultimately, make more sales.
        </p>
        <p>
          You can also manage all your orders from different marketplaces like Poshmark, Mercari, eBay and Depop on the
          OneShop app and print all your shipping labels from your smartphone. Requesting package pick-up, ordering free
          shipping boxes, and viewing pending orders are also accessible on your smartphones in the OneShop app.
        </p>
        <p>
          Make your online and offline work much more efficient by letting OneShop do all your daily listing work.{' '}
          <a href='https://tools.oneshop.com/signup'>Sign up for OneShop</a> and take advantage of its{' '}
          <>{Constants.Marketing.TrialDuration}</>-day free trial with no outright payment required! This automation
          service lets you have more time in your hands to focus more on other essential things to grow your online
          business.
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
